import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import { isAdmin, isLoggedIn } from "./lib/auth";
import Login from "./pages/Login";
import ResetPassword from "./pages/ResetPassword";
import ModeSelection from "./pages/ModeSelection";
import Contacts from "./pages/Contacts";
import CreateContact from "./pages/CreateContact";
import StartExperience from "./pages/StartExperience";
import Events from "./pages/Events";
import CreateEvent from "./pages/CreateEvent";
import AddEventContact from "./pages/AddEventContact";
import EventContacts from "./pages/EventContacts";
import Results from "./pages/Results";
import FireExtinguisherStats from "./pages/FireExtinguisherStats";
import AdminUsers from "./pages/AdminUsers";

/** Requires a login token; otherwise back to the sign-in page. */
const Protected = ({ children }) => (isLoggedIn() ? children : <Navigate to="/" replace />);

/** Requires an admin or Super admin role (the API enforces the same rule). */
const AdminOnly = ({ children }) => (isAdmin() ? children : <Navigate to="/mode-selection" replace />);

const protectedRoutes = [
	["/mode-selection", <ModeSelection />],
	["/users/students", <Contacts />],
	["/users/create", <CreateContact />],
	["/start-experience", <StartExperience />],
	["/events", <Events />],
	["/events/create", <CreateEvent />],
	["/events/fireExtStats", <FireExtinguisherStats />],
	["/events/:id/students", <EventContacts />],
	["/event-mode", <AddEventContact />],
	["/stats", <Results />],
];

function App() {
	return (
		<Router>
			<Routes>
				<Route path="/" element={<Login />} />
				<Route path="/reset-password" element={<ResetPassword />} />
				{protectedRoutes.map(([path, element]) => (
					<Route key={path} path={path} element={<Protected>{element}</Protected>} />
				))}
				<Route
					path="/admin-users"
					element={
						<Protected>
							<AdminOnly>
								<AdminUsers />
							</AdminOnly>
						</Protected>
					}
				/>
				{/* Old URLs kept as redirects */}
				<Route path="/super-admin" element={<Navigate to="/admin-users" replace />} />
				<Route path="/admin" element={<Navigate to="/admin-users" replace />} />
				<Route path="/final-user" element={<Navigate to="/users/students" replace />} />
				<Route path="/group-stats" element={<Navigate to="/stats" replace />} />
				<Route path="/events/student" element={<Navigate to="/events" replace />} />
				<Route path="*" element={<Navigate to={isLoggedIn() ? "/mode-selection" : "/"} replace />} />
			</Routes>
		</Router>
	);
}

export default App;
